import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Text } from '../text';
import { characterCountStaticStyle } from './styles';
// Mapping between Text Area size and counter size
const sizeMap = {
    large: 'medium',
    medium: 'small',
    small: 'small',
};
function CharacterCount({ counterAriaLabel, id, limit, size, value, }) {
    var _a;
    const currentCount = (_a = value === null || value === void 0 ? void 0 : value.toString().length) !== null && _a !== void 0 ? _a : 0;
    return (_jsx(Text, Object.assign({ "aria-label": counterAriaLabel != null
            ? counterAriaLabel({ currentCount, limit })
            : `${currentCount} of ${limit} characters used`, "aria-live": "polite", as: "p", css: characterCountStaticStyle, id: id, role: "status", size: sizeMap[size] }, { children: _jsx("span", Object.assign({ "aria-hidden": true }, { children: `${currentCount} / ${limit}` })) })));
}
export default CharacterCount;
